import React, { useState } from 'react';
import Icon from './AppIcon';

const EmergencyTab = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const emergencyContacts = [
    { label: 'National Emergency', number: '911', icon: 'AlertTriangle' },
    { label: 'Tourist Police', number: '+63 917 123 4567', icon: 'Shield' },
    { label: 'Medical Emergency', number: '117', icon: 'Heart' },
    { label: 'Fire Department', number: '160', icon: 'Flame' },
  ];

  const quickActions = [
    { label: 'Report Issue', icon: 'AlertCircle', action: 'report' },
    { label: 'Find Hospital', icon: 'Hospital', action: 'hospital' },
    { label: 'Embassy Contact', icon: 'Building2', action: 'embassy' },
  ];

  const handleCall = (number) => {
    window.location.href = `tel:${number}`;
  };

  const handleQuickAction = (action) => {
    switch (action) {
      case 'report': alert('Report Issue functionality - Connect to your reporting system');
        break;
      case 'hospital': alert('Find Hospital functionality - Connect to maps/location service');
        break;
      case 'embassy': alert('Embassy Contact functionality - Connect to embassy directory');
        break;
      default:
        break;
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-[999] transition-all duration-300">
      {/* Expanded Content */}
      <div
        className={`bg-white border-t-2 border-red-500 shadow-2xl transition-all duration-300 overflow-hidden ${
          isExpanded ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-4 py-4">
          {/* Emergency Contacts Grid */}
          <div className="mb-4">
            <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
              <Icon name="Phone" size={16} color="#DC2626" />
              Emergency Contacts
            </h3>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
              {emergencyContacts?.map((contact, index) => (
                <button
                  key={index}
                  onClick={() => handleCall(contact?.number)}
                  className="flex items-center gap-2 p-2 bg-red-50 hover:bg-red-100 rounded-lg transition-colors duration-200 border border-red-200"
                >
                  <div className="w-8 h-8 rounded-lg bg-red-500 flex items-center justify-center flex-shrink-0">
                    <Icon name={contact?.icon} size={16} color="#FFFFFF" />
                  </div>
                  <div className="text-left min-w-0">
                    <p className="text-[10px] text-gray-600 truncate">{contact?.label}</p>
                    <p className="text-xs font-bold text-red-600 truncate">{contact?.number}</p>
                  </div>
                </button>
              ))}
            </div>
          </div>

          {/* Quick Actions */}
          <div>
            <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
              <Icon name="Zap" size={16} color="#DC2626" />
              Quick Actions
            </h3>
            <div className="grid grid-cols-3 gap-2">
              {quickActions?.map((action, index) => (
                <button
                  key={index}
                  onClick={() => handleQuickAction(action?.action)}
                  className="flex flex-col items-center gap-1 p-2 bg-gray-50 hover:bg-gray-100 rounded-lg transition-colors duration-200 border border-gray-200"
                >
                  <div className="w-8 h-8 rounded-lg bg-orange-500 flex items-center justify-center">
                    <Icon name={action?.icon} size={16} color="#FFFFFF" />
                  </div>
                  <p className="text-[10px] text-gray-700 text-center">{action?.label}</p>
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Tab Button */}
      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="w-full bg-gradient-to-r from-red-500 via-orange-500 to-orange-400 hover:from-red-600 hover:via-orange-600 hover:to-orange-500 transition-all duration-300 shadow-lg"
      >
        <div className="max-w-[1400px] mx-auto px-4 py-2 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-lg bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <Icon name="AlertTriangle" size={18} color="#FFFFFF" />
            </div>
            <div className="text-left">
              <p className="text-xs font-bold text-white">Emergency Assistance</p>
              <p className="text-[10px] text-white/90">24/7 Support Available</p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <div className="hidden sm:flex items-center gap-1 px-2 py-1 bg-white/20 backdrop-blur-sm rounded-lg">
              <Icon name="Phone" size={14} color="#FFFFFF" />
              <span className="text-xs font-semibold text-white">911</span>
            </div>
            <Icon
              name={isExpanded ? 'ChevronDown' : 'ChevronUp'}
              size={20}
              color="#FFFFFF"
              className="transition-transform duration-300"
            />
          </div>
        </div>
      </button>
    </div>
  );
};

export default EmergencyTab;